
import clsx from "clsx";

export type BadgeVariant =
  | "brand"
  | "success"
  | "warning"
  | "danger"
  | "info"
  | "neutral";

export type BadgeSize = "sm" | "md" | "lg";

export interface BadgeProps {
  variant?: BadgeVariant;
  size?: BadgeSize;
  pill?: boolean;
  children: React.ReactNode;
  className?: string;
}

const variantClasses: Record<BadgeVariant, string> = {
  brand: "badge-brand",
  success: "badge-success",
  warning: "badge-warning",
  danger: "badge-danger",
  info: "badge-info",
  neutral: "badge-neutral",
};

const sizeClasses: Record<BadgeSize, string> = {
  sm: "badge-sm",
  md: "",
  lg: "badge-lg",
};

export function Badge({
  variant = "neutral",
  size = "md",
  pill = true,
  children,
  className,
}: BadgeProps) {
  return (
    <span
      className={clsx(
        "badge",
        variantClasses[variant],
        sizeClasses[size],
        !pill && "rounded-s",
        className
      )}
    >
      {children}
    </span>
  );
}

export default Badge;
